"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESearchPostType = exports.EUserRole = void 0;
var EUserRole;
(function (EUserRole) {
    EUserRole["CUSTOMER"] = "customers";
    EUserRole["PARTNER"] = "partners";
})(EUserRole = exports.EUserRole || (exports.EUserRole = {}));
var ESearchPostType;
(function (ESearchPostType) {
    ESearchPostType["BLOG"] = "blog";
    ESearchPostType["KNOWLEDGE_BASE_ENTRY"] = "knowledge-base-entry";
    ESearchPostType["NEWS_ARTICLE"] = "news-article";
    ESearchPostType["PARTNER_PRODUCT"] = "partner-produkt";
    ESearchPostType["PRODUCT"] = "produkt";
})(ESearchPostType = exports.ESearchPostType || (exports.ESearchPostType = {}));
